import { useState, useEffect } from 'react';

export default function useFingerprint() {
  const [fingerprint, setFingerprint] = useState(null);
  const [components, setComponents] = useState({});

  useEffect(() => {
    async function generate() {
      try {
        // Dynamic import to avoid SSR issues
        const FingerprintJS = await import('@fingerprintjs/fingerprintjs');
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        setFingerprint(result.visitorId);
        setComponents(result.components);
      } catch(e) {
        // Fallback custom fingerprint
        const custom = generateCustomFingerprint();
        setFingerprint(custom.id);
        setComponents(custom.components);
      }
    }
    generate();
  }, []);

  return { fingerprint, components };
}

function generateCustomFingerprint() {
  const components = {
    screen: `${screen.width}x${screen.height}x${screen.colorDepth}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    platform: navigator.platform,
    hardwareConcurrency: navigator.hardwareConcurrency,
    deviceMemory: navigator.deviceMemory || 'unknown',
    plugins: Array.from(navigator.plugins||[]).map(p=>p.name).join(','),
    canvas: getCanvasFingerprint(),
    webgl: getWebGLFingerprint(),
    audio: 'na',
  };

  const str = Object.values(components).join('|');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return { id: Math.abs(hash).toString(36), components };
}

function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('NaijaPredict🏆', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('NaijaPredict🏆', 4, 17);
    return canvas.toDataURL().slice(-50);
  } catch(e) { return 'na'; }
}

function getWebGLFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl');
    if (!gl) return 'na';
    const renderer = gl.getParameter(gl.RENDERER);
    const vendor = gl.getParameter(gl.VENDOR);
    return `${vendor}~${renderer}`.slice(0, 50);
  } catch(e) { return 'na'; }
}
